import classNames from 'classnames';
import { FC, useCallback, useRef, useState } from 'react';

import { useBreakpoint } from '../../hooks/useBreakpoint';
import { Breakpoint } from '../../utils/breakpoint';

import { BonusInfoLabelToolTip } from './bonus-info-label-tooltip';

export interface IBonusInfoLabelProps {
  limit: number;
  classes?: string;
}
type ShowCoordinatesT = {
  top: number;
  left: number;
};
export const BonusInfoLabel: FC<IBonusInfoLabelProps> = ({ limit, classes }) => {
  const [tooltipShown, setTooltipShown] = useState<ShowCoordinatesT | null>(null);
  const breakpoint = useBreakpoint();

  const elementRef = useRef(null);

  const handleClick = useCallback(() => {
    if (elementRef.current) {
      const rect = (elementRef.current as any).getBoundingClientRect();
      setTooltipShown((c: ShowCoordinatesT | null) => {
        return {
          top: breakpoint > Breakpoint.Lg ? rect.bottom : rect.top - 60,
          left: breakpoint > Breakpoint.Lg ? rect.left + rect.width / 2 : rect.left + rect.width / 3,
        };
      });
    }
  }, [breakpoint]);

  return (
    <div
      className={classNames('flex items-center justify-center text-[10px] mb-[18px] cursor-pointer', classes)}
      onClick={handleClick}
      ref={elementRef}
    >
      <span> Оплатите часть бонусами</span>
      <div className="ml-1 text-gray-400 ">
        <div className="bg-gray-500 rounded-full w-[12px] h-[12px] text-[8px] text-white text-center ">?</div>
        {tooltipShown && (
          <div className="z-[99999]" style={{ position: 'fixed', top: tooltipShown.top, left: tooltipShown.left }}>
            <BonusInfoLabelToolTip
              text={`Бонусными рублями можно оплатить до ${limit}% от стоимости тарифа`}
              onClose={() => setTooltipShown(null)}
            />
          </div>
        )}
      </div>
    </div>
  );
};
